interface Props {
    filtered: boolean
}
const FilterIcon = (props: Props) => {
    const color = props?.filtered ? "#0152FB" : "#667085"
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
            <path d="M1.75 4H12.25" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.0835 7.5H9.91683" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.8335 11H8.16683" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default FilterIcon